import { createFileRoute } from "@tanstack/react-router";

import { ContactPage } from "src/pages/ContactPage";

export const Route = createFileRoute("/_public/contact")({
  component: ContactPage,
  ssr: true,
});
